export default __webpack_public_path__ + "static/media/userinfoblock.3e2b5209.svg";